import React, { useState } from "react";
import ErrorMessage from "../../../../../Shared/error-message/errorMessage";
import Styles from "../../Shared/sharedStyles.module.scss";
import {
  buttonStyles,
  StyledButton,
} from "../../../../../Shared/button/button";

function ChequeOcrPopup({ handleResponse }: any) {
  const errorObject = {
    chequeError: false,
    consentError: false,
  };

  const [error, setError] = useState({ ...errorObject });
  const [isChecked, setIsChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [uploadedCheque, setUploadedCheque] = useState<any>("");

  const handleFileUpload = async (cheque: any, consent: string) => {
    const chequeEncoded: any = await toBase64(cheque);
    const char = ",";
    const chequeIndex = chequeEncoded.indexOf(char);
    const finalChequeImage =
      chequeIndex !== -1 ? chequeEncoded.substring(chequeIndex + 1) : "";
    handleResponse({ finalChequeImage, consent }, setLoading);
  };

  function toBase64(image: any) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = reject;
    });
  }

  function handleCheck() {
    if (!uploadedCheque) {
      setError(() => ({
        ...error,
        chequeError: true,
      }));
      return false;
    } else if (!isChecked) {
      setError(() => ({
        ...error,
        consentError: true,
      }));
      return false;
    }
    const consent = isChecked === true ? "Y" : "N";
    setLoading(true);
    handleFileUpload(uploadedCheque, consent);
  }
  return (
    <div className={`${Styles.content}`}>
      <div className={`${Styles.infoForm} pl-2`}>
        <hr />
        <p className="mt-2">Fill in the below details to run verification</p>
        <div className="d-flex flex-column">
          <div className="d-flex flex-column mb-4 ">
            <label className={`${Styles.label} flex-grow-1`}>
              Cheque Image
            </label>
            <input
              id="id-input-file-cheque-ocr" data-testid="id-input-file-cheque-ocr"
              type="file"
              accept=".png,.jpeg,.jpg"
              onChange={(e: any) => setUploadedCheque(e.target.files[0])}
              className={Styles.fileUpload}
            />
            {error.chequeError && (
              <ErrorMessage>Please upload a file</ErrorMessage>
            )}
          </div>
          <div className="pt-4 pl-4 pb-4 mt-4 d-flex flex-column">
            <div className="d-flex align-items-center py-0 gap-2">
              <input
                type="checkbox"
                className={`${Styles.formCheckInput} `}
                id="id-input-cheque-ocr" data-testid="id-input-cheque-ocr"
                onChange={(e: any) => setIsChecked(e.target.checked)}
              />
              <p className={`${Styles.ackText} mb-0`}>
                I hereby agree, to let zoop.one verify my data for verification
              </p>
            </div>
            {error.consentError && (
              <ErrorMessage>Please provide consent!</ErrorMessage>
            )}
          </div>
          <div className={`${Styles.buttonGroup}`}>
            <StyledButton
              id="id-submit-button-cheque-ocr"
              hoverStyle={{ ...buttonStyles.primary.hover }}
              isLoading={loading}
              style={{ ...buttonStyles.primary.normal }}
              onClick={() => {
                setTimeout(() => setError({ ...errorObject }), 2000);
                handleCheck();
              }}
            >
              Run Verification
            </StyledButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChequeOcrPopup;
